import { render, staticRenderFns } from "./AdminUsecases.vue?vue&type=template&id=154da387&scoped=true"
import script from "./AdminUsecases.vue?vue&type=script&lang=js"
export * from "./AdminUsecases.vue?vue&type=script&lang=js"
import style0 from "./AdminUsecases.vue?vue&type=style&index=0&id=154da387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154da387",
  null
  
)

export default component.exports